// Bancos de licencia general en Panama (Superintendencia de Bancos de Panama, https://www.superbancos.gob.pa/en/gen-info-banks/general-license).
// Son sugerencias para el formulario: el cliente puede escribir otro banco si no esta aqui.
const BANCOS_PANAMA = [
  'Atlas Bank', 'BAC International Bank', 'Banco Aliado', 'Banco Azteca', 'BBP Bank', 'Banco Davivienda',
  'Banco Delta', 'Banco de Bogotá', 'Banisi', 'Banco Ficohsa', 'Banco General', 'BICSA',
  'Banco Lafise', 'Bladex', 'Banco La Hipotecaria', 'Bancolombia', 'Pacific Bank', 'Banco Pichincha',
  'Prival Bank', 'Banesco', 'Bank of China', 'BCT Bank', 'BI-Bank', 'Canal Bank', 'Capital Bank',
  'Citibank', 'Credicorp Bank', 'Global Bank', 'Banistmo', 'KEB Hana Bank', 'Mega International Commercial Bank',
  'Mercantil Banco', 'Metrobank', 'MMG Bank', 'Multibank', 'St. Georges Bank', 'Scotiabank',
  'Towerbank', 'Unibank', 'ICBC',
];

export default BANCOS_PANAMA;
